<template>
	<div class="card-body">
		<form>
			<input-text label="race" v-model="name" />
			<input-text label="size" v-model="size" />
			<input-text label="type" v-model="type" />
			<input-number label="hit_points" v-model="hp" />
			<basic-race-trait v-for="(trait, index) in traits" :key="`racial-property-${index}`" :trait="trait" :index="index" />
			<div class="text-center">
				<button type="button" class="btn btn-sm btn-secondary" @click="addTrait()">Add Racial Feature</button>
			</div>
		</form>
	</div>
</template>

<script>
function mapEverything( mod, properties ){
	var computed = {}
	properties.forEach(property => {
		computed[property] = {
			get () {
				return this.$store.getters[`${mod}/get`](property)
			},
			set ( value ){
				this.$store.commit(`${mod}/set`,{
					property,
					value
				})
			}
		}
	})
	return computed
}
import InputNumber from '@/components/InputNumber.vue'
import InputText from '@/components/InputText.vue'
import BasicRaceTrait from '@/components/basics/BasicRaceTrait'

export default {
	components: {
		InputNumber,
		InputText,
		BasicRaceTrait,
	},
	methods: {
		addTrait() {
			this.$store.commit('character/race/addTrait')
		}
	},
	computed: {
		...mapEverything('character/race',[
			'name',
			'size',
			'type',
			'hp',
			'traits',
		]),
	},
}
</script>

<style scoped>

</style>